"use strict";
exports.__esModule = true;
//# sourceMappingURL=entity-hourly-sales.type.js.map